import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SquareButton = function SquareButton(props) {
    const { dark, arrow } = props.config;
    const btnClass = classNames(
        'SquareButton',
        dark ? 'dark' : 'light',
        arrow && `arrow-${arrow}`
    );

    return (
        <div className={btnClass}>
            <button onClick={props.handleClick}>
                {props.config.arrow ? (<span />) : props.children}
            </button>
        </div>
    );
};

SquareButton.propTypes = {
    handleClick: PropTypes.func,
    config: PropTypes.object,
    children: PropTypes.node
};

SquareButton.defaultProps = {
    config: {}
};

export default SquareButton;
